import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsUpcCodeStyles {
    wrapper?: InjectableCss;
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const UpcCodeStyles: ProductDetailsUpcCodeStyles = {
    wrapper: {
        css: css`
            margin-bottom: 0 !important;
        `,
    },
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 15px;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin: 7px 5px 5px 5px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = UpcCodeStyles;

const ProductDetailsUpcCode: React.FC<Props> = ({ product }) => {
    if (!product.detail || !product.detail.upcCode) {
        return null;
    }

    return (
        <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsUpc">
            <Typography {...styles.labelText}>{translate("UPC:")}</Typography>
            {product.detail.upcCode}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsUpcCode),
    definition: {
        displayName: "UpcCode",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
